<template>
    <div>
        <el-form
            ref="form"
            :model="form"
            :rules="rules"
            v-loading="isBusy"
            element-loading-spinner="el-icon-loading"
            label-width="170px"
        >
            <el-form-item prop="user_id" label="User">
                <el-select v-model="form.user_id" placeholder="Select User" class="w-100" filterable>
                    <el-option
                        v-for="option in userOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="brand_id" label="Brand">
                <el-select v-model="form.brand_id" placeholder="Select Brand" class="w-100">
                    <el-option
                        v-for="option in brandOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="contact_id" label="Contact">
                <el-select
                    v-model="form.contact_id"
                    filterable
                    clearable
                    remote
                    placeholder="Search Contact"
                    :remote-method="searchContact"
                    :loading="contactsLoading"
                    class="w-100"
                >
                    <el-option
                        v-for="option in contactOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="begin_at" label="Begin">
                <el-date-picker
                    v-model="form.begin_at"
                    type="datetime"
                    placeholder="Select date and time"
                    :format="dateFormat"
                    :value-format="formDateFormat"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item prop="end_at" label="End">
                <el-date-picker
                        v-model="form.end_at"
                        type="datetime"
                        placeholder="Select date and time"
                        :format="dateFormat"
                        :value-format="formDateFormat"
                >
                </el-date-picker>
            </el-form-item>
        </el-form>
        <button class="btn btn-create px-4" @click="store">Store</button>
    </div>
</template>

<script>
  import BaseForm from '../form';

  export default {
    extends: BaseForm,

    props: {
      users: Array,
      initialContacts: Array,
      brands: Array,
      searchContactUrl: String
    },

    data() {
      return {
        form: {
          contact_id: null,
          user_id: null,
          brand_id: null,
          begin_at: null,
          end_at: null
        },
        contactsLoading: false,
        contacts: [],
        rules: {
          contact_id: [{validator: this.fieldExternalValidator}],
          user_id: [{validator: this.fieldExternalValidator}],
          brand_id: [{validator: this.fieldExternalValidator}],
          begin_at: [{validator: this.fieldExternalValidator}],
          end_at: [{validator: this.fieldExternalValidator}],
        }
      }
    },

    computed: {
      /**
       * @return {Array}
       */
      userOptions() {
        return _.map(this.users, (item, key) => {
          return {label: item.full_name, value: item.id}
        });
      },

      /**
       * @return {Array}
       */
      brandOptions() {
        return _.map(this.brands, (item, key) => {
          return {label: item.title, value: item.id}
        });
      },

      /**
       * @return {Array}
       */
      contactOptions() {
        return _.map(this.contacts, (item, key) => {
          return {label: this.formatContact(item), value: item.id}
        });
      },

      /**
       * @return {String}
       */
      dateFormat() {
        return config('format.element.short.datetime');
      },

      /**
       * @return {String}
       */
      formDateFormat() {
        return config('format.isoLocal');
      },
    },

    methods: {
      /**
       * @return {string}
       */
      formatContact(contact) {
        return String(contact.full_name).trim() + ' (' + String(contact.phone_number).trim() + ')';
      },

      /**
       * @param {Object} model
       */
      initForm({contact_id = null, user_id = null, brand_id = null, begin_at = null, end_at = null}) {
        this.form = {
          contact_id: contact_id,
          user_id: user_id,
          brand_id: brand_id,
          begin_at: _.get(begin_at, 'datetime', null),
          end_at: _.get(end_at, 'datetime', null),
        };
      },

      /**
       * @return {Object}
       */
      getForm() {
        return _.assign({}, this.form, {
          _method: this.method
        });
      },

      /**
       * @param {string} text
       */
      searchContact(text) {
        this.contactsLoading = true;
        axios.get(this.searchContactUrl, {params: {text: text}})
          .then((({data: {data}}) => this.contacts = data))
          .catch(() => this.contacts = [])
          .finally(() => this.contactsLoading = false);
      }
    },

    mounted() {
      this.contacts = this.initialContacts;
    }
  }
</script>
